
import React from 'react';
import { Calendar } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious
} from "@/components/ui/pagination";

interface AppointmentHistoryPaginationProps {
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
}

export const AppointmentHistoryPagination: React.FC<AppointmentHistoryPaginationProps> = ({
  currentPage,
  totalPages,
  setCurrentPage
}) => {
  if (totalPages <= 1) {
    return null;
  }
  
  return (
    <Pagination className="mt-4">
      <PaginationContent>
        <PaginationItem>
          {currentPage === 1 ? (
            <Button 
              variant="ghost"
              disabled 
              className="opacity-50 cursor-not-allowed"
              onClick={() => {}}
            >
              <span className="sr-only">Go to previous page</span>
              <span className="flex items-center gap-1">
                <Calendar className="h-4 w-4" />
                <span>Previous</span>
              </span>
            </Button>
          ) : (
            <PaginationPrevious 
              onClick={() => setCurrentPage(Math.max(currentPage - 1, 1))}
              className="cursor-pointer"
            />
          )}
        </PaginationItem>
        
        {[...Array(totalPages)].map((_, i) => (
          <PaginationItem key={i}>
            <PaginationLink
              onClick={() => setCurrentPage(i + 1)}
              isActive={currentPage === i + 1}
            >
              {i + 1}
            </PaginationLink>
          </PaginationItem>
        ))}
        
        <PaginationItem>
          {currentPage === totalPages ? (
            <Button 
              variant="ghost"
              disabled 
              className="opacity-50 cursor-not-allowed"
              onClick={() => {}}
            >
              <span className="sr-only">Go to next page</span>
              <span className="flex items-center gap-1">
                <span>Next</span>
                <Calendar className="h-4 w-4" />
              </span>
            </Button>
          ) : (
            <PaginationNext 
              onClick={() => setCurrentPage(Math.min(currentPage + 1, totalPages))}
              className="cursor-pointer"
            />
          )}
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
};
